/* tslint:disable */
/* eslint-disable */
/* @relayHash d460761345f7bb735e1f7f038a35937f */

import { ConcreteRequest } from "relay-runtime";
export type TimeUnitType = "BUSINESS_DAY" | "DAY" | "MINUTE" | "%future added value";
export type CreateHoldRequestInput = {
    itemId?: string | null;
    userId?: string | null;
    sellerId?: string | null;
    vertical?: string | null;
    duration?: number | null;
    timeUnit?: TimeUnitType | null;
    clientMutationId?: string | null;
};
export type holdRequestMutationVariables = {
    input: CreateHoldRequestInput;
    userId: string;
};
export type holdRequestMutationResponse = {
    readonly createHoldRequest: {
        readonly item: {
            readonly isOnHold: boolean | null;
            readonly hasRequestedHoldForBuyer: boolean | null;
            readonly relevantHoldForBuyer: {
                readonly isRequested: boolean | null;
            } | null;
        } | null;
    } | null;
};
export type holdRequestMutation = {
    readonly response: holdRequestMutationResponse;
    readonly variables: holdRequestMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateHoldRequestInput!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isOnHold",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "userId"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasRequestedHoldForBuyer",
  "args": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isRequested",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "holdRequestMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createHoldRequest",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHoldRequestPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantHoldForBuyer",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Hold",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "holdRequestMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "createHoldRequest",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateHoldRequestPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "item",
            "storageKey": null,
            "args": null,
            "concreteType": "Item",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "relevantHoldForBuyer",
                "storageKey": null,
                "args": (v3/*: any*/),
                "concreteType": "Hold",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "holdRequestMutation",
    "id": "app-buyer-finding/292.0.0-2020-11-20T23:59:39.967Z/holdRequestMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'e3373454beb2c0ca06dab030fec8c47f';
export default node;
